export default __webpack_public_path__ + "static/media/homeg10sm.f692ed1e.svg";